/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import * as React from "react";
import Dropdown from 'react-bootstrap/Dropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons';
import { NavLink, Link } from "react-router-dom";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import './Sidebar.css';
import GestureDetect from "../GestureDetect";
import Icon from "../Icon";
import BaseCom from "../BaseCom";
import NavMenu from "./NavMenu";

export class NavItem extends React.Component {

    render() {
        return (<li className="nav-item">
            <NavLink to={'/console/' + this.props.href} className="nav-link d-flex align-items-center" end={this.props.end}>
                {this.props.icon ? (<FontAwesomeIcon icon={this.props.icon} className="me-1 d-block" />) : ''}
                <div>{this.props.label}</div>
                {this.props.successExtra ? <div className="badge bg-success ms-1">{this.props.successExtra}</div> : ''}
            </NavLink>
        </li>);

    }
}

export class NavHeader extends React.Component {

    render() {
        return (<div className="nav-header text-uppercase p-1 m-1 mb-1 pb-1">{this.props.label}</div>);
    }
}

export class NavGroup extends React.Component {
    render() {
        return (<ul className="nav nav-pills flex-column">
            {this.props.children}
        </ul>);

    }
}

export const SidebarGlobal = {
    setSubNav(children) { },
    clearSubNav() { }
};

class Sidebar extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            user: props.user,
            toggle: window.innerWidth >= 768,
            subNav: null,
            search: {}
        }
        SidebarGlobal.setSubNav = this.setSubNav;
        SidebarGlobal.clearSubNav = this.clearSubNav;
    }

    async componentDidMount() {
        await this.getLoginAsync();
        this.props.onSidebarToggle?.(this.state.toggle);
    }

    setSubNav = (children) => {
        setTimeout(() => {
            this.setState({ subNav: children });
        }, 100);
    }

    clearSubNav = () => {
        this.setState({ subNav: null });
    }

    search = (e) => {
        if (e) e.preventDefault();
        if (this.state.search.query)
            this.props.navigate('/search/' + encodeURIComponent(this.state.search.query));
        else
            this.props.navigate('/');
    }

    toggle = (on) => {
        this.setState({ toggle: on });
        this.props.onSidebarToggle(on);
    }

    returnToAdmin = async () => {
        let j = await this.postOrAlert('/api/admin/user/impersonate/return', {});
        if(j.errorCode === 0)
            document.location.assign('/console/admin/user')
    }


    render() {

        return (<>
            <GestureDetect onSwipeLeft={() => this.toggle(true)} onSwipeRight={() => this.toggle(false)} />
            <nav className="c-nav navbar --bg-primary">
                <div className="container-fluid d-flex justify-content-between align-items-center c-nav-content">
                    <div className="d-block me-2">
                        <button onClick={() => this.toggle(!this.state.toggle)} className="navbar-toggler d-none d-md-block" type="button" data-bs-toggle="collapse" data-bs-target="#sidebarToggle" aria-controls="sidebarToggle" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="icon-wrapper">
                            <Link to="/console">
                                <img src={this.getLogo()} alt="" className={'d-block d-md-none icon bg-dark rounded'} />
                            </Link>
                        </div>
                    </div>
                    <div className="d-flex justify-content-end">
                        {this.state.subNav}
                        <Dropdown className="ms-2" style={{ zIndex: '9992' }}>
                            <Dropdown.Toggle className="d-flex align-items-center text-white text-decoration-none dropdown-toggle" id="dropdownUser1" data-bs-toggle="dropdown" aria-expanded="false" variant="secondary">
                                <strong>
                                    <FontAwesomeIcon icon={fa.faUser} /> <span className="d-none d-md-inline">
                                    {this.state.user ? this.state.user?.firstName + ' ' + this.state.user?.lastName : ''}
                                    </span>
                                    </strong>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="dropdown-menu dropdown-menu-dark text-small shadow" aria-labelledby="dropdownUser1">
                                {this.state.user?.impersonatedByUser ? <Dropdown.Item className="dropdown-item" onClick={e => { e.preventDefault(); this.returnToAdmin(); }}>Back to {this.state.user.impersonatedByUser.firstName + ' ' + this.state.user.impersonatedByUser.lastName}</Dropdown.Item> : ''}
                                <Dropdown.Item role="button" className="dropdown-item" onClick={e => { e.preventDefault(); this.props.navigate('/logout'); }}>Logout</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
            </nav>
            <nav className={'c-sidebar d-md-flex flex-column flex-shrink-0 --bg-primary ' + (this.state.toggle ? 'c-sidebar-open' : 'c-sidebar-close')}>
                <div className="mb-2 p-3 pt-0 pb-1">
                    <Link to="/" className="d-flex justify-content-center align-items-center mb-1 mb-md-0 me-md-auto text-white text-decoration-none p-3">
                        <img src={this.getLogo()} alt="" className={'d-block img-fluid rounded'} style={{ maxWidth: '100%' }} />
                    </Link>
                </div>
                <div className="mb-auto">
                    <NavMenu />
                </div>
            </nav>
            <nav className="c-nav-mobile d-flex d-md-none align-items-center justify-content-evenly">
                <NavLink to="/console/dashboard" className="c-nav-mobile-item">
                    <Icon icon="faGaugeSimpleHigh" />
                    <span>Dashboard</span>
                </NavLink>
                <NavLink to="/console/menu" className="c-nav-mobile-item">
                    <Icon icon="faBars" />
                    <span>Menu</span>
                </NavLink>
            </nav>
        </>);
    }
}

export default withParamsAndNavigate(Sidebar);